let protocol = document.location.protocol;
// let basePath = protocol + process.env.NODE_ENV === 'production' ? '//www.carziliao.com' : '//daida.mxkl.com';
const APIBasePath = '/WebAPI';
const WeChatH5APPID = 'wx3bde6debacdcdd0c';


const getFilePath = param => APIBasePath + param;
const getStaticFilePath = (param,prefix) => {
    if (param != null && (param.indexOf("http://") == 0 || param.indexOf("https://") == 0)) {
        return param;
    }
    if (param != null && param.startsWith("companyimage")) {
        return "https://cdn2.carziliao.com"+ (param.indexOf("/") == 0 ? "" : "/") + param; // 注册
    } else if(prefix){
        if(param.indexOf(prefix)==0){
            return "https://cdn2.carziliao.com"+ (param.indexOf("/") == 0 ? "" : "/") + param; // 注册
        }
        return "https://cdn2.carziliao.com" + prefix + (param.indexOf("/") == 0 ? "" : "/") + param; // 注册
    }
    else {
        return param;
    }
}; //'/m' +

const checkLogin = (path) => {
    var user = localStorage.getItem("User");
    if (user == null) {
        sessionStorage.setItem("redirectUrl", path)
        this.$router.push({ path: "/login" });
    }
    return user;
}

const isNull = obj => !obj || typeof(obj) == "undefined" || obj == null || obj == "null"

const getUserInfo = () => {
    let user = localStorage.getItem("User");

    if (!isNull(user)) {
        return JSON.parse(user);
    } else {
        return user;
    }
}

const loadUser = user => {
    if (!isNull(user)) {
        user.memberSystemId=user.systemId
        localStorage.setItem("User", JSON.stringify(user));
        localStorage.setItem("AccessToken", user.accessToken);
        localStorage.setItem("RefreshToken", user.refreshToken);
    }
}

const isWxBind = () => {
    let user = getUserInfo();
    return !isNull(user) && !isNull(user.weChat)
}


// const isMobile = () => {
//     let flag = navigator.userAgent.match(
//         /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
//     );
//     return flag;
// }

const isMobile = () => {
    let winWidth = 0;
    let winHeight = 0;
    // 获取窗口宽度
    if (window.innerWidth)
        winWidth = window.innerWidth;
    else if ((document.body) && (document.body.clientWidth))
        winWidth = document.body.clientWidth;
    // 获取窗口高度
    if (window.innerHeight)
        winHeight = window.innerHeight;
    else if ((document.body) && (document.body.clientHeight))
        winHeight = document.body.clientHeight;
    // 通过深入 Document 内部对 body 进行检测，获取窗口大小
    if (document.documentElement && document.documentElement.clientHeight && document.documentElement.clientWidth) {
        winHeight = document.documentElement.clientHeight;
        winWidth = document.documentElement.clientWidth;
    }
    return winWidth < 700;
}

// const formatDate = date => new Date(new Date(date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')

const formatDate = function(date, fmt) {
    if (!date) {
        return '';
    }
    fmt = fmt || "yyyy-MM-dd hh:mm:ss";
    date = new Date(date);
    let ret;
    const opt = {
        "y+": date.getFullYear().toString(), // 年
        "M+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "h+": date.getHours().toString(), // 时
        "m+": date.getMinutes().toString(), // 分
        "s+": date.getSeconds().toString(), // 秒
        "S+": date.getMilliseconds() //毫秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}

export default {
    APIBasePath,
    WeChatH5APPID,
    getFilePath,
    getStaticFilePath,
    checkLogin,
    getUserInfo,
    formatDate,
    isNull,
    isWxBind,
    isMobile,
    loadUser
};
